export interface NotificationPreferenceBaseModel {
    notificationType: number;
    channel: number;
    enabled: boolean;
}

export interface NotificationPreferenceModel extends NotificationPreferenceBaseModel {
    isDefault: boolean;
}

export interface GetNotificationPreferencesResponse {
    preferences: NotificationPreferenceModel[];
}

export interface PatchNotificationPreferencesRequest {
    preferences: NotificationPreferenceBaseModel[];
}

export enum NotificationType {
    NewLead = 1,
    AcceptLead = 2,
    RejectLead = 3,
    PartnerInvite = 4,
    MeetingOccurred = 5,
    DealOccurred = 6,
    SuggestedProspects = 7,
    StripeReminder = 8,
    IntroductionNudge = 9,
    IntroductionRating = 10,
    MotivationalNudge = 11,
}

export enum NotificationChannel {
    Push = 1,
    Email = 2,
    Slack = 3,
}

export interface NotificationPreferenceRow {
    notificationType: number;
    channels: Partial<Record<NotificationChannel, NotificationPreferenceModel>>;
}

export interface NotificationPreferenceItem {
    key: string;
    notificationType: number;
    channel: number;
    enabled: boolean;
    isDefault: boolean;
}

export function createPreferenceKey(notificationType: number, channel: number): string {
    return `${notificationType}_${channel}`;
}

export interface NotificationTypeMeta {
    label: string;
    tooltip?: string;
}

export const NOTIFICATION_TYPE_META: Record<number, NotificationTypeMeta> = {
    1: {
        label: 'New lead',
        tooltip: 'Any new leads submitted by referrer.',
    },
    2: {
        label: 'Lead accepted',
        tooltip: 'Sent when a partner accepts a lead you shared.',
    },
    3: {
        label: 'Lead rejected',
        tooltip: 'Sent when a partner declines a lead you shared.',
    },
    4: {
        label: 'Partner Invite',
        tooltip: 'Sent when a partner intvites a referrer.',
    },
    5: {
        label: 'Meeting occurred',
        tooltip: 'Sent when a meeting payout is issued.',
    },
    6: {
        label: 'Deal occurred',
        tooltip: 'Sent when a deal payout is issued.',
    },
    7: {
        label: 'Suggested Prospects',
        tooltip: 'Sent when you have new suggested prospects.',
    },
    8: {
        label: 'Stripe Reminder',
        tooltip: 'Sent when there is an issue with Stripe Connected account.',
    },
    11: {
        label: 'Motivational Nudge',
        tooltip: 'Sent to encourage engagement based on your activity.',
    },
};
